import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'
import { time } from 'settings/custom/win'
import { delay } from 'utils/Delay'

let timer = 0
let id = -1

function toKeysArray(line) {
  signal.dispatch('LINES:SHOW', line.id)
  return line.path.map((pos) => pos.toString())
}

function animate(positions, total) {
  function update([key, item]) {
    if (positions.includes(key)) {
      item.animation(total)
    }
    else {
      item.setType('dimm')
    }
  }

  if (game.models.CascadeModel.get().isCascade === true) {
    return
  }

  Object.entries(game.models.SpinModel.get().reelItems).forEach(update)
  if (reelsSettings.slideReel) {
    Object.entries(game.models.SpinModel.get().slideItems).forEach(update)
  }

  if (reelsSettings.explosionReel) {
    Object.entries(game.models.SpinModel.get().explosionItems).forEach(update)
  }
}

function next() {
  reset()
  if (id + 1) {
    animate(
      toKeysArray(
        game.models.WinModel.get().winLines[
          id++ % game.models.WinModel.get().winLines.length
        ],
      ),
      false,
    )
    timer = delay(time).then(next)
  }
}

function reset() {
  timer = 0
  signal.dispatch('LINES:HIDE')
  Object.values(game.models.SpinModel.get().reelItems).forEach((x) =>
    x.setType(),
  )
}

function playNext() {
  if (game.models.GameModel.requestAgainAllowed) {
    stop()
    return
  }
  id = 0
  if (!timer && game.models.WinModel.get().winLines.length) {
    next()
  }
}

function playAll() {
  animate(game.models.WinModel.get().winLines.flatMap(toKeysArray), true)
  timer = delay(time).then(next)
}

function stop() {
  clearTimeout(timer)
  id = -1
  reset()
}

export const WinService = { start }

function start() {
  signal.on('ACTION:WIN-BIG', playAll)
  signal.on('ACTION:WIN-SMALL', playAll)
  signal.on('STATE:IN:BET', playNext)
  signal.on('STATE:OUT:BET', stop)
}
